import React, { memo } from 'react'

import { classnames, Grid, Icon, Tree } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, oneOf } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { HISTORY_VIEW } from 'Pods/ThreeDStudio/Store/constants'

const iconSize = { height: '14px', width: '14px' }

const VIEWS = [
  { id: HISTORY_VIEW.GRID, icon: Grid },
  { id: HISTORY_VIEW.TREE, icon: Tree },
]

function ViewToggle({ view, onChange: handleChange }) {
  const t = useTranslation()

  return (
    <div className="variations-tab__views" role="group" aria-label={t('viewerSidebar.enhance.variations.views.label')}>
      {VIEWS.map(({ id, icon }) => (
        <button
          key={id}
          type="button"
          aria-pressed={id === view}
          className={classnames(
            'variations-tab__view',
            'cgt-caption-semibold',
            id === view && 'variations-tab__view--active',
          )}
          onClick={() => handleChange(id)}
        >
          <Icon svgComponent={icon} size={iconSize} notSpaced />
          {t(`viewerSidebar.enhance.variations.views.${id}`)}
        </button>
      ))}
    </div>
  )
}

ViewToggle.propTypes = {
  view: oneOf(Object.values(HISTORY_VIEW)).isRequired,
  onChange: func.isRequired,
}

export default memo(ViewToggle)
